import React from 'react';
import { Box, Heading, Icon, Text } from '@chakra-ui/react';

export default function BenefitCard({ benefit }) {
  return (
    <Box h="100%" p={6} bg="surface.default" borderRadius="lg"
      border="1px solid" borderColor="border.default" textAlign="center">
      <Icon as={benefit.icon} boxSize={10} color="accent.default" mb={4} aria-hidden="true" />
      <Heading as="h3" fontSize="md" mb={2}>
        {benefit.title}
      </Heading>
      <Text fontSize="sm" color="text.secondary">
        {benefit.description}
      </Text>
    </Box>
  );
}
